// SS Recommendations Global Manager - User Interaction Only
window.SSRecommendationsManager = window.SSRecommendationsManager || {
  sections: {},
  initialized: false,
  userHasInteracted: false,
  
  init: function() {
    if (this.initialized) return;
    this.initialized = true;
    
    // Only listen for user interactions
    this.setupInteractionListeners();
  
  },
  
  setupInteractionListeners: function() {
    var self = this;
    
    // Listen for various user interactions
    window.addEventListener('mousemove', function() {
      self.onUserInteraction();
    }, { passive: true, once: true });
    
    window.addEventListener('touchstart', function() {
      self.onUserInteraction();
    }, { passive: true, once: true });
    
    window.addEventListener('click', function() {
      self.onUserInteraction();
    }, { passive: true, once: true });
    
    window.addEventListener('scroll', function() {
      self.onUserInteraction();
    }, { passive: true, once: true });
    
    window.addEventListener('keydown', function() {
      self.onUserInteraction();
    }, { passive: true, once: true });
  },
  
  registerSection: function(sectionId) {
    var container = document.getElementById('ss-recommendations-' + sectionId);
    var template = document.getElementById('ss-recommendations-template-' + sectionId);
    
    if (!container || !template) return;
    
    this.sections[sectionId] = {
      container: container,
      template: template,
      loaded: false,
      preloadTimer: null
    };
    
    // Set up hover listener for this specific section
    this.setupHoverListener(sectionId);
  },
  
  setupHoverListener: function(sectionId) {
    var self = this;
    var container = this.sections[sectionId].container;
    
    container.addEventListener('mouseenter', function() {
      if (self.userHasInteracted) {
        self.preloadSection(sectionId);
      }
    });
  },
  
  onUserInteraction: function() {
    if (this.userHasInteracted) return;
    
    this.userHasInteracted = true;
    
    // Start scroll checking for all sections after user interaction
    window.addEventListener('scroll', this.checkAllSections.bind(this), { passive: true });
    
    // Check immediately in case sections are already in viewport
    this.checkAllSections();
  },
  
  checkAllSections: function() {
    var windowHeight = window.innerHeight;
    var hasUnloadedSections = false;
    
    for (var sectionId in this.sections) {
      var section = this.sections[sectionId];
      if (!section.loaded) {
        hasUnloadedSections = true;
        var rect = section.container.getBoundingClientRect();
        
        // Load if element is within 150px of viewport
        if (rect.top < windowHeight + 150 && rect.bottom > -150) {
          this.loadSection(sectionId);
        }
      }
    }
    
    // Remove scroll listener if all sections are loaded
    if (!hasUnloadedSections) {
      window.removeEventListener('scroll', this.checkAllSections.bind(this));
    }
  },
  
  preloadSection: function(sectionId) {
    var section = this.sections[sectionId];
    if (!section || section.loaded) return;
    
    // Clear existing timer
    if (section.preloadTimer) clearTimeout(section.preloadTimer);
    
    // Preload with delay for hover intent
    var self = this;
    section.preloadTimer = setTimeout(function() {
      self.loadSection(sectionId);
    }, 300);
  },
  
  loadSection: function(sectionId) {
    var section = this.sections[sectionId];
    if (!section || section.loaded) return;
    
    section.loaded = true;
    
    // Remove loading placeholder
    var placeholder = section.container.querySelector('.ss-loading-placeholder');
    if (placeholder) placeholder.remove();
    
    // Inject template content
    section.container.innerHTML = section.template.innerHTML;
    section.container.dataset.loaded = 'true';
    
    // Clean up timer
    if (section.preloadTimer) {
      clearTimeout(section.preloadTimer);
      section.preloadTimer = null;
    }
  }
};
